import { Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';

// Gráfico ApexCharts carregado sob demanda: a biblioteca vira um chunk separado, baixado só no BI Financeiro,
// em vez de entrar no bundle inicial de todas as telas (como aconteceria com o ng-apexcharts).
@Component({
	selector: 'app-bi-grafico',
	template: `
		<div #alvo></div>
		<p class="text-muted small text-center py-2 mb-0" *ngIf="erro">Não foi possível desenhar o gráfico.</p>
	`,
})
export class BiGraficoComponent implements OnChanges, OnDestroy {
	@Input() opcoes: any;
	@ViewChild('alvo', { static: true }) alvo: ElementRef<HTMLDivElement>;

	erro = false;
	private grafico: any;
	private versao = 0;

	async ngOnChanges() {
		const versao = ++this.versao;
		this.destruir();
		if (!this.opcoes) {
			return;
		}
		try {
			const { default: ApexCharts } = await import('apexcharts');
			if (versao !== this.versao) {
				return; // opções trocaram enquanto a biblioteca carregava
			}
			this.grafico = new ApexCharts(this.alvo.nativeElement, this.opcoes);
			await this.grafico.render();
			this.erro = false;
		} catch (e) {
			console.log(e);
			this.erro = true;
		}
	}

	ngOnDestroy() {
		this.versao++;
		this.destruir();
	}

	private destruir() {
		if (this.grafico) {
			this.grafico.destroy();
			this.grafico = null;
		}
	}
}
